<template>
    <v-app id="login">
      <v-content>
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md6 lg5>
              <v-card class="pf-box-shadow-2 border-radius-10 pt-4 px-3 pb-3">
                <v-card-text>
                  <!-- <div class="layout column align-center pb-4">
                    <img src="/static/login_logo.png" alt="Parent Finder">
                  </div> -->
                  <v-flex class="flex-center">
                    <h3 class="pf-login-head">Username Recovery</h3>
                  </v-flex>
                  <p v-if="emailSent" class="mt-3 pf-text-dark font-weight-medium">We've sent you an email with your username. If the email doesn't show up soon, check your spam folder.</p>
                  <p v-else class="mt-3 pf-text-dark font-weight-medium">Enter your email address associated with your Parentfinder account.</p>
                  <v-form v-if="!emailSent">
                    <template>
                      <v-form ref="forgotUsernameForm">
                        <v-text-field 
                          label="Enter your email address" type="text" v-model.trim="email"
                          height="40"
                          v-on:keyup.enter="submitEmail"
                          :rules="[emailRules]"
                        ></v-text-field>
                      </v-form>
                    </template>
                  </v-form>
                  <v-flex style="display: inline-grid">
                    <span v-if="error" class="pf-text-red">{{ error }}</span>
                    <!-- <span v-if="!emailSent" class="cursor-pointer pf-text-link" @click="backToLogin">Back to Login</span> -->
                  </v-flex>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn v-if="emailSent" class="pf-btn pf-bg-green login-btn border-radius-10" @click="backToLogin" ref="sigInBtn">Back To Login</v-btn>
                  <v-btn class="pf-btn pf-bg-green login-btn border-radius-10" v-else @click="submitEmail" ref="sigInBtn" :loading="loading">Continue</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
                <v-flex class="flex-space-between mt-4 mx-3">
                  <!-- <a class="pf-text-dark font-weight-bold" :href="config.host">Home</a> -->
                  <span class="pf-text-dark font-weight-bold cursor-pointer" @click="backToLogin">Back to Login</span>
                  <a class="pf-text-dark font-weight-bold" target="_blank" :href="config.helpForm">Need Help?</a>
                </v-flex>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
  </template>
<script>
/* global session, $t store config */
import { request } from '../../helpers/helpers';
import swal from 'sweetalert2';
export default {

  beforeRouteEnter (to, from, next) {
    if (session.isOnline()) {
      let role = session.getSession().user.role;
      let homePage = (role === 'admin' ? '/admin/dashboard' : (['agency', 'caseworker'].indexOf(role) > -1 ? '/agency/dashboard' : (role === 'parent' ? '/dashboard' : '/dashboard')));
      next({ path: homePage });
    } else {
      next();
    }
  },

  data: () => ({
    config,
    loading: false,
    email: '',
    error: '',
    emailSent: false,
    emailRules: (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(v) || 'Please enter valid email address',
  }),
  computed: {
    
  },
  methods: {
    async submitEmail () {
      if (this.$refs.forgotUsernameForm.validate()) {
        this.error = '';
        this.loading = true;
        try {
          if (this.email) {
            let { error, data, status } = await request('User/ForgotUsername', 'POST', {
              email: this.email
            });
            this.loading = false;
            if (error) {
              this.error = typeof error === 'string' ? (error.indexOf('Record not found') > -1 ? 'No user found with the given information' : error) : 'Oops, failed to process the request.';
            } else {
              this.error = '';
              this.emailSent = true;
            }
          }
        } catch (err) {
          console.log(err);
          this.error = 'Oops, failed to process the request.';
        }
      }
    },
    backToLogin () {
      this.email = '';
      this.accountType = '';
      this.error = '';
      this.emailSent = false;
      this.$router.push('/login');
    }
  }
};
</script>
<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
  


// WEBPACK FOOTER //
// src/pages/ResetPassword/ForgotUsername.vue